import { loadStripe } from '@stripe/stripe-js'

let _stripe = null
let _elements = null
let _paymentElement = null

export const stripeClient = {
  name: 'stripe',
  usesInternalSubmitButton: false,

  async mount(host, ctx) {
    if (!ctx?.publishableKey) {
      throw new Error('stripeClient.mount requires ctx.publishableKey')
    }
    if (!ctx?.clientSecret) {
      throw new Error('stripeClient.mount requires ctx.clientSecret')
    }
    if (!_stripe) {
      _stripe = await loadStripe(ctx.publishableKey)
    }
    _elements = _stripe.elements({ clientSecret: ctx.clientSecret })
    _paymentElement = _elements.create('payment')
    _paymentElement.mount(host)
  },

  async submit(ctx) {
    if (!_stripe || !_elements) {
      throw new Error('stripeClient.submit called before mount')
    }
    const { error, paymentIntent } = await _stripe.confirmPayment({
      elements: _elements,
      confirmParams: { return_url: ctx?.returnUrl },
      redirect: 'if_required'
    })
    if (error) {
      return { status: 'failed', details: error }
    }
    return { status: 'success', orderId: ctx?.orderId, details: paymentIntent }
  },

  async destroy() {
    if (_paymentElement) {
      try { _paymentElement.unmount() } catch { /* ignore */ }
    }
    _elements = null
    _paymentElement = null
  }
}
